import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Alert, Button, message, Result, Tag, Typography } from "antd";

import "./fps.scss";
import { fps_info } from "../../apis/paymentGateway";
import { replaceUrlByParams } from "../../utils/api";
import { PAGE } from "../../utils/constants";
import { AppContext } from "../../App";
import Qrcode from "qrcode.react";
import { useCallback } from "react";

function FPSPage() {
  let history = useHistory();
  const { pid } = useParams();
  const { appSetting, loading, setLoading } = useContext(AppContext);
  const { Text, Paragraph } = Typography;

  const [fpsInfo, setFpsInfo] = useState(null);

  const getFPSInfo = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fps_info();
      if (res.error) {
        message.error("操作無效，重新定向", 1, () => history.goBack());
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        setFpsInfo(res.fps);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [history, setLoading]);

  useEffect(() => {
    getFPSInfo();
  }, [getFPSInfo]);

  return (
    <>
      {fpsInfo && (
        <Result
          className="fps"
          icon={
            fpsInfo.qrCode ? <Qrcode value={fpsInfo.qrCode} size={200} /> : null
          }
          title="請使用 FPS轉數快 掃描上方的二維碼付款"
          extra={
            <>
              {/* <div className="title">或</div>
              <Paragraph className="paragraph">
                <Text>
                  請使用支援 FPS轉數快 的應用程式填寫 「快速支付系統識別碼」
                  <br />
                  於收款人信息填寫你的「參考編號」
                  <br />
                  並轉帳金額
                </Text>
              </Paragraph> */}
              <Paragraph className="fpsInfo">
                <Text>
                  商戶名稱：{fpsInfo.merchantName}
                  <br />
                </Text>
                {/* <Text>
                  快速支付系統識別碼：{fpsInfo.fpsId}
                  <br />
                </Text> */}
                <Text>
                  參考編號：
                  {fpsInfo.referenceNumber} <br />
                </Text>
                <Text>
                  金額：
                  <Text strong>${fpsInfo.transactionAmount / 100}</Text>
                </Text>
              </Paragraph>
              <Button
                type="primary"
                style={{ marginBottom: "16px" }}
                onClick={() => {
                  history.push(
                    `${replaceUrlByParams(PAGE.APPLICATION_RESULT, {
                      ":pid": pid,
                    })}`
                  );
                }}
              >
                完成付款並返回
              </Button>
            </>
          }
        >
          <Text>
            *閣下可隨時於課程主頁<Tag>{appSetting.checkResultButton}</Tag>
            <span>以</span>
            {appSetting.checkResultForm.map((field, i) => {
              return <Tag key={i}>{field.name}</Tag>;
            })}
            登入付款
          </Text>
          <div style={{ marginTop: "16px" }}>
            <Alert
              message="繳費狀態更新需要數個工作天。請留意你是否已繳費，以免重覆付款。如有問題請聯絡我們"
              type="error"
            />
          </div>
        </Result>
      )}
    </>
  );
}

export default FPSPage;
